import { render, staticRenderFns } from "./tbbj.vue?vue&type=template&id=d74f590a&scoped=true"
import script from "./tbbj.vue?vue&type=script&lang=js"
export * from "./tbbj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74f590a",
  null
  
)

export default component.exports